import React from "react";
import {
    Col,
    Drawer,
    Form,
    Select,
    Upload,
    message,
    Row,
} from "antd";
import { Button } from "src/components/actions/button";
import { CloseSvg, RotateClockwiseSvg, SaveSvg } from "src/components/Svg";
import { useAppData } from "src/store/app-data";
import styled from "styled-components";
import { UploadOutlined } from "@ant-design/icons";
import * as toGeoJSON from "@tmcw/togeojson";
import { DOMParser } from "@xmldom/xmldom";

export function FileUploaderDrawer({
                                       title,
                                       onClose,
                                       onSave,
                                       pointOption,
                                   }) {
    const layoutConfig = useAppData((state) => state.layoutConfig);
    const [form] = Form.useForm();

    const handleClose = () => {
        form.resetFields();
        onClose();
    };

    async function parseFileToGeoJson(file) {
        const isKml = file.name.endsWith(".kml");
        const isJson = file.name.endsWith(".json") || file.name.endsWith(".geojson");

        if (!isKml && !isJson) {
            throw new Error("Поддерживаются только .kml и .geojson");
        }

        const text = await file.text();

        if (isKml) {
            const parser = new DOMParser();
            const kmlDom = parser.parseFromString(text, "text/xml");
            return toGeoJSON.kml(kmlDom);
        } else {
            return JSON.parse(text);
        }
    }

    async function onSubmit(values) {
        try {
            const file = values.geo?.fileList?.[0]?.originFileObj;
            if (!file) {
                throw new Error("Файл не найден");
            }

            const geojson = await parseFileToGeoJson(file);

            if (!geojson || !geojson.features || geojson.features.length === 0) {
                throw new Error("Файл не содержит допустимых геометрий");
            }

            await onSave({
                pointId: values.pointId,
                geo: geojson,
            });

            message.success("Зона успешно загружена");
            form.resetFields();
            onClose();
        } catch (e) {
            console.error(e);
            message.error("Ошибка: " + e.message);
        }
    }

    return (
        <DrawerEdit
            width={layoutConfig.isMobile ? "90%" : "80%"}
            title={title}
            onClose={handleClose}
            open
        >
            <FormEdit form={form} layout={"vertical"} onFinish={onSubmit}>
                <StyledFormItem
                    key={"drawer_pointId"}
                    label={"Выберите точку"}
                    name={"pointId"}
                    rules={[{ required: true, message: "Выберите точку!" }]}
                >
                    <Select
                        showSearch
                        optionFilterProp="label"
                        options={pointOption}
                        placeholder="Начните вводить название..."
                    />
                </StyledFormItem>

                <StyledFormItem
                    name={"geo"}
                    label={"Файл зоны (.kml, .geojson)"}
                    key={"drawer_geo"}
                    rules={[{ required: true, message: "Загрузите файл" }]}
                >
                    <Upload
                        accept={".geojson,.json,.kml"}
                        beforeUpload={() => false}
                        maxCount={1}
                    >
                        <Button icon={<UploadOutlined />}>Нажмите для загрузки</Button>
                    </Upload>
                </StyledFormItem>

                <ButtonRow>
                    <ButtonCol>
                        <Button
                            danger
                            onClick={() => form.resetFields()}
                            icon={<RotateClockwiseSvg />}
                        >
                            Сбросить
                        </Button>
                    </ButtonCol>
                    <ButtonCol>
                        <Button onClick={handleClose} icon={<CloseSvg />}>
                            Закрыть
                        </Button>
                    </ButtonCol>
                    <ButtonCol>
                        <Button icon={<SaveSvg />} type="primary" htmlType="submit">
                            Сохранить
                        </Button>
                    </ButtonCol>
                </ButtonRow>
            </FormEdit>
        </DrawerEdit>
    );
}

const DrawerEdit = styled(Drawer)``;
const FormEdit = styled(Form)``;
const StyledFormItem = styled(Form.Item)`
  margin-bottom: 16px;
`;
const ButtonCol = styled(Col)`
  padding-bottom: 5px;
`;
const ButtonRow = styled(Row)`
  align-items: center;
  justify-content: flex-end;
  margin-top: 10px;

  .ant-col {
    margin-left: 0.4em;
  }
`;
